import { EntityState } from '@reduxjs/toolkit';
import { Translate } from '@ff-os/shared-utils/types/Translate';
import { mergeInputsInto } from '@ff-resource-plugins/prefabs-shared/merge-logic/mergeInputsIntoPrefab';
import { Prefab } from '@ff-resource-plugins/prefabs-shared/Prefab';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { createPaintables } from '@ff-scene-plugins/gift-shared/paintables';

export const createPrefabPreviewPaintables = (
    prefab: Prefab,
    userInputs: EntityState<GiftJson.Input<any>>,
    variant: GiftJson.Variant<any>,
    translate: Translate,
    jwt: string | null
) => {
    const variables = Object.values(prefab.variables.entities) as GiftJson.Variable<any>[];
    const inputs = mergeInputsInto(prefab, userInputs, translate);
    return createPaintables(variables, inputs.entities, variant, jwt, 'icon');
};